/* global hljs */

export default function useHighlighting () {
    document.addEventListener( "DOMContentLoaded", () => {
        hljs && hljs.initHighlightingOnLoad()
    })
}
